import { useState } from 'react';
import './contactForm.css';

const ContactForm: React.FC = () => {
  const [submitted, setSubmitted] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    phoneNumber: '',
    email: '',
    property: '',
    request: '',
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await fetch("https://capnserver.com/onDemand", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });
      setSubmitted(true);
    } catch (e) {
      setSubmitted(false);
      setHasError(true);
    }
  };

  return (
    <div className="form-container">
      {submitted && (
        <div className="submitted-view">
          <h2>Thank you!</h2>
          <p>Your request has been submitted successfully. We’ll get back to you shortly.</p>
        </div>
      )}
      {hasError && (
        <div className="submitted-view">
          <h2>Error!</h2>
          <p>Your request hit an error. Please refresh and try again.</p>
        </div>
      )}
      {!submitted && !hasError && (
        <>
          <h2 className="form-title">Let us know how we can help you!</h2>
          <form onSubmit={handleSubmit} className="form">
            {/* Name */}
            <div className="form-group">
              <label htmlFor="name">Name</label>
              <input
                type="text"
                id="name"
                name="name"
                placeholder="Lora"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>

            {/* Phone Number */}
            <div className="form-group">
              <label htmlFor="phoneNumber">Phone number</label>
              <input
                type="tel"
                id="phoneNumber"
                name="phoneNumber"
                placeholder="+1 (000) 000 0000"
                value={formData.phoneNumber}
                onChange={handleChange}
                required
              />
            </div>

            {/* Email */}
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                placeholder="examplemail@gmail.com"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            {/* Property */}
            <div className="form-group">
              <label htmlFor="property">Property</label>
              <input
                type="text"
                id="property"
                name="property"
                placeholder="example property"
                value={formData.property}
                onChange={handleChange}
                required
              />
            </div>

            {/* Request */}
            <div className="form-group">
              <label htmlFor="request">Request</label>
              <textarea
                id="request"
                name="request"
                placeholder="Write your request..."
                value={formData.request}
                onChange={handleChange}
                required
              />
            </div>

            {/* Submit Button */}
            <button type="submit" className="submit-btn">
              Submit
            </button>
          </form>
        </>
      )}
    </div>
  );
};

export default ContactForm;
